<div class="ec-page">

  <!-- Header -->
  <div class="ec-header">
    <div class="ec-title">
      <i class="material-icons">dialpad</i>
      <div>
        <h5>Extension Configurator</h5>
        <span class="ec-sub">Create and manage SIP extension pools</span>
      </div>
    </div>
    <div class="ec-header-actions">
      <button class="ec-btn ec-btn-accent" (click)="showForm = true" [disabled]="showForm || loading">
        <i class="material-icons">add</i> Add Extension
      </button>
      <button class="ec-btn" (click)="load()" [disabled]="loading">
        <i class="material-icons">refresh</i> Refresh
      </button>
    </div>
  </div>

  <!-- Add form -->
  <div class="ec-form-card" *ngIf="showForm">
    <div class="ec-form-title">New Extension</div>
    <div class="ec-form-row">
      <div class="ec-field">
        <label>Extension Number</label>
        <input class="ec-input" [(ngModel)]="form.extensionNumber" placeholder="e.g. 1011" maxlength="10" />
      </div>
      <div class="ec-field">
        <label>SIP Password</label>
        <input class="ec-input" [(ngModel)]="form.password" placeholder="e.g. Ext1011@Grms" />
      </div>
      <div class="ec-field">
        <label>Pool Type</label>
        <select class="ec-select" [(ngModel)]="form.poolType">
          <option *ngFor="let pt of poolTypes" [value]="pt.code">{{ pt.label }}</option>
        </select>
      </div>
      <div class="ec-field ec-field-actions">
        <button class="ec-btn ec-btn-accent" (click)="save()" [disabled]="saving || !form.extensionNumber.trim() || !form.password.trim()">
          <i class="material-icons">{{ saving ? 'hourglass_empty' : 'save' }}</i>
          {{ saving ? 'Saving…' : 'Save' }}
        </button>
        <button class="ec-btn" (click)="cancelForm()" [disabled]="saving">Cancel</button>
      </div>
    </div>
    <div class="ec-error" *ngIf="saveError">{{ saveError }}</div>
  </div>

  <!-- Load error -->
  <div class="ec-error ec-error-block" *ngIf="loadError">{{ loadError }}</div>

  <!-- Loading -->
  <div class="ec-loading" *ngIf="loading">
    <i class="material-icons spin">sync</i> Loading extensions…
  </div>

  <!-- Pool groups -->
  <ng-container *ngIf="!loading">

    <div class="pool-block" *ngFor="let g of grouped">
      <div class="pool-heading">
        <span class="pool-tag">{{ g.pool.label }}</span>
        <span class="pool-count">{{ g.exts.length }} extension{{ g.exts.length === 1 ? '' : 's' }}</span>
      </div>
      <div class="ext-table-wrap">
        <table class="ext-table">
          <thead>
            <tr>
              <th>Extension #</th>
              <th>Pool</th>
              <th>Status</th>
              <th>Reserved By</th>
              <th>Since</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of g.exts" [class.row-reserved]="e.status === 'RESERVED'">
              <td class="ext-num">{{ e.extensionNumber }}</td>
              <td><span class="pool-pill">{{ e.poolLabel }}</span></td>
              <td>
                <span class="status-badge"
                  [class.badge-available]="e.status === 'AVAILABLE'"
                  [class.badge-reserved]="e.status === 'RESERVED'">
                  {{ e.status === 'RESERVED' ? 'In Use' : 'Available' }}
                </span>
              </td>
              <td class="td-user">{{ e.reservedByUserName || '—' }}</td>
              <td class="td-sub">{{ e.reservedAt ? (e.reservedAt | date:'dd/MM HH:mm') : '—' }}</td>
              <td>
                <button class="del-btn" title="Delete extension"
                        [disabled]="e.status === 'RESERVED' || deletingIds.has(e.id)"
                        (click)="deleteExt(e)">
                  <i class="material-icons">{{ deletingIds.has(e.id) ? 'hourglass_empty' : 'delete_outline' }}</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Extensions with unknown pool types (future-proofing) -->
    <div class="pool-block" *ngIf="ungrouped.length">
      <div class="pool-heading">
        <span class="pool-tag">Other</span>
        <span class="pool-count">{{ ungrouped.length }} extension{{ ungrouped.length === 1 ? '' : 's' }}</span>
      </div>
      <div class="ext-table-wrap">
        <table class="ext-table">
          <thead><tr><th>Extension #</th><th>Pool</th><th>Status</th><th>Reserved By</th><th>Since</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let e of ungrouped" [class.row-reserved]="e.status === 'RESERVED'">
              <td class="ext-num">{{ e.extensionNumber }}</td>
              <td><span class="pool-pill">{{ e.poolLabel || e.poolType }}</span></td>
              <td>
                <span class="status-badge"
                  [class.badge-available]="e.status === 'AVAILABLE'"
                  [class.badge-reserved]="e.status === 'RESERVED'">
                  {{ e.status === 'RESERVED' ? 'In Use' : 'Available' }}
                </span>
              </td>
              <td class="td-user">{{ e.reservedByUserName || '—' }}</td>
              <td class="td-sub">{{ e.reservedAt ? (e.reservedAt | date:'dd/MM HH:mm') : '—' }}</td>
              <td>
                <button class="del-btn" [disabled]="e.status === 'RESERVED' || deletingIds.has(e.id)" (click)="deleteExt(e)">
                  <i class="material-icons">{{ deletingIds.has(e.id) ? 'hourglass_empty' : 'delete_outline' }}</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ec-empty" *ngIf="!grouped.length && !ungrouped.length">
      No extensions configured yet. Click "Add Extension" to create one.
    </div>

  </ng-container>

</div>
